export default __webpack_public_path__ + "static/cdp-58894cb33c822a77b4671c04149e2d89.png";